import { defineComponent as _defineComponent } from 'vue';
import Layout from '@/app/ui/Layout.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup: function setup(__props) {
    return {
      __sfc: true,
      Layout: Layout
    };
  }
});